import React from 'react';
import { Sheet } from '@amzn/storm-ui';
import { MobileNavSheetInnerContainer } from './styles';

/**
 * This component handles the container formatting
 * logic of components that are rendered in the Sheet
 * StormUI component
 */

// there are some typing issues with storm ui components and the following
// eslint disable rule is needed

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MobileNavSheet = ({
  children,
  hasInnerPadding = true,
  closeButton,
  ...sheetProps
}) => {
  return (
    <Sheet {...sheetProps} closeButton={closeButton} padding="none">
      <MobileNavSheetInnerContainer hasInnerPadding={hasInnerPadding}>
        {children}
      </MobileNavSheetInnerContainer>
    </Sheet>
  );
};
